export const responseAmazonAdvertisingSubscription = {
  data: {
    type: 'Subscription',
    id: '227',
    attributes: {
      price: 0,
      status: 'active',
      date_start: '2021-12-30T12:55:19',
      date_end: '2021-12-30T12:55:19',
      auto_renew: 1,
      created_at: '2021-12-30T12:55:22.862203',
      modified_at: '2021-12-30T12:55:22.862219',
      quantity: 1,
      stripe_subscription_id: '',
      name: 'amazon-advertizing-mock-1',
      rabbit_payload_successful: 0,
      primary_job_id: null,
      pipeline: null,
      invalid_subscription: 0,
      invalidated_at: null,
      notified_at: null,
      canonical_name: null,
      account_id: 342,
      product_id: 40,
      product_plan_id: null,
      remote_identity_id: 22,
      storage_group_id: 108,
      user_id: 309,
      history_requested: 0
    },
    relationships: {
      account: {
        data: {
          type: 'Account',
          id: '342'
        }
      },
      product: {
        data: {
          type: 'Product',
          id: '40'
        }
      },
      product_plan: {
        data: null
      },
      remote_identity: {
        data: {
          type: 'RemoteIdentity',
          id: '22'
        }
      },
      storage_group: {
        data: {
          type: 'StorageGroup',
          id: '108'
        }
      },
      user: {
        data: {
          type: 'User',
          id: '309'
        }
      }
    }
  },
  included: [
    {
      type: 'StorageGroup',
      id: '108',
      attributes: {
        product_id: 47,
        name: 'my datalake test',
        key_name: 'afad95d7a191146f- my - datalake - test'
      }
    }
  ]
};